import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {
  createSwissparkStyle, updateInnerBuffer
} from './swissparkStyle.js';

import GeoJSON from 'ol/format/GeoJSON';
import {Z_INDEX} from "../constants";


/**
 * @param {string} apiUrl
 * @return {VectorSource}
 */
export function createSwissparkVectorSource(apiUrl) {
  const source = new VectorSource({
    attributions: 'Schweizmobil',
    url: `${apiUrl}4/swissparks.geojson?srid=21781`,
    format: new GeoJSON({
      dataProjection: 'EPSG:21781',
    }),
  });
  source.set('olcs_minimumLevel', 7);
  source.set('olcs_skip', false);
  return source;
}

/**
 * @param {VectorSource} source
 * @return {VectorLayer}
 */
export function createSwissparkVectorLayer(source) {
  const layer = new VectorLayer({
    source: source,
    zIndex: Z_INDEX.ROUTE,
    extent: [420000, 30000, 900000, 350000], // swiss extent
    style: createSwissparkStyle(),
    style3d: createSwissparkStyle(true),
    layername: 'Swisspark', // select swisspark print layout
    name: 'Swisspark',
    altitudeMode: 'clampToGround',
  });
  layer.set('kind', 'geojson_swisspark_layer');
  layer.on('postrender', (event) => updateInnerBuffer(event, layer));

  return layer;
}
